module.exports = __webpack_public_path__ + "static/img/logo.1e34836.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cereshop/home/logo.png
// module id = Wt6R
// module chunks = 18